// extracted by mini-css-extract-plugin
export var chevronIcon = "_cd-2";
export var teamName = "_cd-1";
export var teamSwitcherButton = "_cd-0";